

// Predefined question categories for login suggestions
export const SOLVE_QUESTIONS = [
  "How can I increase the accuracy of sensor data in harsh environments?",
  "What methods can be used to improve the efficiency of energy storage systems?",
  "How can I enhance the resolution of optical imaging systems for microstructures?",
  "What techniques can reduce noise interference in neural network models?",
  "How can I optimize the performance of nanomaterials for heat conduction?",
  "What are the best approaches to improve data transfer speed in quantum computing?",
  "How can I increase the lifespan of lithium-ion batteries in high-load conditions?",
  "What methods can prevent corrosion in metal-based materials under extreme conditions?",
  "How can I reduce signal degradation in long-distance fiber optic cables?",
  "What are the most effective ways to control the growth rate of microorganisms in bioreactors?"
];

export const BENCHMARK_QUESTIONS = [
  "How does my AI-based diagnostic tool compare to existing market solutions?",
  "How does my energy-efficient computing system benchmark against industry standards?",
  "What are the strengths and weaknesses of my nanotech-based packaging solution?",
  "How does my biotechnological plastic recycling method evaluate against competitors?",
  "What is the market performance of my wearable health tech compared to others?",
  "How does my textile waste recycling solution compare to current technologies?",
  "What is the energy consumption efficiency of my data center system compared to industry leaders?",
  "How does my microplastic degradation solution benchmark against similar technologies?",
  "What are the key differences between my clean tech and other market innovations?",
  "How does my health tech wearable perform in terms of patient outcomes compared to existing devices?"
];

export const LANDSCAPE_QUESTIONS = [
  "What technologies are available for improving energy storage systems?",
  "What are the latest innovations in nanomaterials for heat management?",
  "Which researchers are developing AI models for healthcare diagnostics?",
  "What solutions exist for reducing plastic waste in manufacturing?",
  "What technologies are being explored for energy-efficient data centers?",
  "Which universities are working on advanced robotics for industrial applications?",
  "What AI technologies are being developed for predictive maintenance?",
  "What are the recent advancements in biotechnology for wastewater treatment?",
  "What innovations exist in quantum computing for faster data processing?",
  "Which researchers are focusing on sustainable packaging technologies?"
];

// Function to get random questions for login suggestions
export const getRandomLoginSuggestions = () => {
  // Get one random question from each category
  const randomSolveQuestion = SOLVE_QUESTIONS[Math.floor(Math.random() * SOLVE_QUESTIONS.length)];
  const randomBenchmarkQuestion = BENCHMARK_QUESTIONS[Math.floor(Math.random() * BENCHMARK_QUESTIONS.length)];
  const randomLandscapeQuestion = LANDSCAPE_QUESTIONS[Math.floor(Math.random() * LANDSCAPE_QUESTIONS.length)];
  
  return [
    {
      title: "Solving a problem",
      prompt: randomSolveQuestion,
    },
    {
      title: "Benchmarking technologies", 
      prompt: randomBenchmarkQuestion,
    },
    {
      title: "Landscaping technical field",
      prompt: randomLandscapeQuestion,
    },
  ];
};

export const FALLBACK_SAMPLE_PROMPTS = [
  {
    title: "Solving a problem",
    prompt: "Show flood irrigation innovations ready for licensing.",
  },
  {
    title: "Benchmarking technologies",
    prompt: "Any AI from universities for irrigation?",
  },
  {
    title: "Landscaping technical field",
    prompt: "What pumping systems are available in U.S. universities?",
  },
];

export const COLLABORATION_TYPES = [
    "Licence Ready IP",
    "Co-Develop IP",
    "Host Innovation Challenge",
    "Sponsor Academic Research",
    "Consult Academic Expert",
    "Access Lab Testing",
    "Fund University Spinout",
    "Fund POC Project",
    "Shape Innovation Policy",
    "Other or Undecided"
];

export const COLLABORATION_LEADS = [
    "Lead Myself",
    "Involve My Team",
    "Assign R&D Team",
    "Nominate Product Owner",
    "Appoint External Consultant",
    "Engage Spinout"
];

export const COLLABORATION_TIMELINES = [
    "Select one",
    "Within 3 months",
    "3-6 months",
    "6-12 months",
    "More than 12 months"
];

export const RD_BUDGETS = [
    "Select one",
    "<$50,000",
    "$50,000 - $100,000",
    "$100,000 - $500,000",
    ">$500,000"
];

/** Interests required before For You will generate. Was 5, dropped to 1.
 *  Must stay in sync with api.py::MIN_INTERESTS_FOR_RECOMMENDATIONS and
 *  db_ops.py::get_cached_recommendations — a mismatch there means results are
 *  cached and never read back, so every page load regenerates. */
export const MIN_INTERESTS_FOR_RECOMMENDATIONS = 1;
